<template>
  <DeclaredGoodsComponent :item="model"/>
</template>
<script>

import VueHtml2pdf from 'vue-html2pdf'
import CompoundCoursePart from "@/models/CompoundCoursePart";
import DeclaredGoodsModel from "@/models/DeclaredGoodsModel";
import DeclaredGoodsComponent from "@/components/DeclaredGoodsComponent.vue";

export default {
  name: "DeclaredGoodsSite",
  components: {
    DeclaredGoodsComponent,
  },
  data: () => ({
    model: new DeclaredGoodsModel({})
  }),
  props: {
    item: {
      type: CompoundCoursePart
    }
  },
  methods: {}
}
</script>


<style scoped>
.container {
  border-style: solid;
  border-width: 2px;
  border-bottom: 0;
  border-right: 0;
}

.rightborder {
  border-style: solid;
  border-width: 2px;
  border-bottom: 0;
}

.w50 {
  width: 50%;
}

.w60 {
  width: 60%;
}

.w40 {
  width: 40%;
}
</style>
